// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2NVWV","buttons":"RemoveExpirationActionButtons_buttons__1UjWb"};